import '@vebox/etui-system';
import '../utilities/responsive.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useContext, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { b as _extends, a as _objectSpread2 } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Accordion/Accordion.js';
import '../Accordion/AccordionSection.js';
import '../H5/H5.js';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '../Accordion/utils/focus.js';
import '@vebox/etui-colors';
import 'react-dom';
import 'react-spring/renderprops.cjs';
import '../Badge/Badge.js';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import '../Chip/Chip.js';
import 'lodash.isnil';
import './utils.js';
import FilterPanelContent from './FilterPanelContent.js';
import './state/constants.js';
import './state/actions.js';
import FilterPanelContext from './FilterPanelContext.js';
import '../SideDrawer/utils.js';
import SideDrawer from '../SideDrawer/SideDrawer.js';
import '../Tabs/Tabs.js';
import '../Tabs/TabsList.js';
import '../Tabs/Tab.js';
import '../ScrollingMenu/defaultSettings.js';
import '../ScrollingMenu/utils/index.js';
import '../ScrollingMenu/InnerWrapper.js';
import '../ScrollingMenu/ScrollingMenu.js';
import '../ScrollingMenu/ArrowWrapper.js';
import './Group/GroupTitle.js';
import './Group/Group.js';
import './SummarySection/SummarySectionChip.js';
import './SummarySection/FilterChips.js';
import './SummarySection/SummarySection.js';

const FilterDrawer = ({
  title,
  children,
  noFiltersSummaryLabel,
  componentLabels,
  summaryFieldsMetadata,
  styles = {},
  useTabs,
  drawerProps = {},
  showSummary
}) => {
  var _styles$drawer;
  const {
    state
  } = useContext(FilterPanelContext);
  return /*#__PURE__*/createElement(SideDrawer, _extends({
    placement: "right",
    useContainerOverflowHidden: true,
    useOverlay: true
  }, drawerProps, {
    collapsed: !state.isDrawerOpen,
    styles: {
      root: _objectSpread2({
        overflowX: 'hidden',
        width: 'auto'
      }, (_styles$drawer = styles.drawer) === null || _styles$drawer === void 0 ? void 0 : _styles$drawer.root)
    }
  }), /*#__PURE__*/createElement(FilterPanelContent, {
    summaryFieldsMetadata: summaryFieldsMetadata,
    styles: styles.content,
    noFiltersSummaryLabel: noFiltersSummaryLabel,
    componentLabels: componentLabels,
    title: title,
    useTabs: useTabs,
    showSummary: showSummary
  }, children));
};

export default FilterDrawer;
